import { FoodDrumstickOffOutlineIcon } from './FoodDrumstickOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id CC221369-59E9-45B7-9CBD-79AB2828689A
 * name food-drumstick-off-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-drumstick-off-outline.svg
 * tags
 * - Food / Drink 
 */
export const ChickenLegOffOutlineIcon = FoodDrumstickOffOutlineIcon;
export default ChickenLegOffOutlineIcon